import ConfirmationModal from "components/Modals/ConfirmationModal"

import { ConfirmCancellationModalProps } from "models/bookingOrdersCancellation"
import { useI18n } from "providers/I18n"

function ConfirmCancellationModal(props: ConfirmCancellationModalProps) {
  const { t } = useI18n()

  const onClickAcceptButton = () => {
    props.onAccept()
  }

  const onClickCancelButton = () => {
    props.onCancel()
  }

  return (
    <ConfirmationModal
      open={props.isOpen}
      type="primary_destructive"
      onCancel={onClickCancelButton}
      onSubmit={onClickAcceptButton}
      title={t("bo.cancel.confirm.modal.title")}
      description={t("bo.cancel.confirm.modal.description")}
      submitLabel={t("bo.cancel.confirm.modal.button")}
    />
  )
}

export default ConfirmCancellationModal
